Vue.component('asset-preview-actions', {
    props: ['asset'],
    template: `
        <div class="dropdown text-center" v-if="asset">
            <a href="#" class="p2 text-dark" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fal fa-2x fa-ellipsis-v"></i>
            </a>
            <div class="dropdown-menu" aria-labelledby="dropdownMenu2">
                <template v-if="asset.asset_type === 'simple'">
                    <a :href="'/team/assets/' + asset.id + '/edit'" class="dropdown-item" target="_blank">Edit Asset</a>
                </template>
                <template v-else>
                    <a :href="'/team/bundles/' + asset.id + '/details'" class="dropdown-item" target="_blank">Edit Asset</a>
                </template>
                <a @click.prevent="removeAsset" href="#" class="dropdown-item">Remove Asset</a>
                <a :href="'/team/assets/' + asset.id" class="dropdown-item" target="_blank">Preview Asset</a>
            </div>
        </div>
    `,
    methods: {
        removeAsset() {
            const _this = this;
            swalc(['Are you sure?', 'This will remove the asset from "Preview and Post"'], (result) => {
                if (result) {
                    axios
                        .put(`/api/team/preview-assets/${this.asset.id}`, {
                            status: 0,
                        })
                        .then((response) => {
                            Bus.$emit('previewAssetRemoved', _this.asset);
                            this.$noty.success('Asset Removed');
                        });
                }
            });
        },
    },
});
